import { render } from "./my.vue?vue&type=template&id=1b6dd6c6&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"

import "./my.vue?vue&type=style&index=0&id=1b6dd6c6&lang=css&scoped=true"
import "./my.vue?vue&type=style&index=1&id=1b6dd6c6&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6dd6c6"]])

export default __exports__